import { IAboutTab } from '../../settings';
import { AboutTab as AboutTabComponent, AboutTabWithIcons } from '../../components/AboutTab';
import { FC, ReactElement, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { selectIsMoscowOrMO } from 'shared/selectors/locations/selectIsMoscowOrMO';

interface IAboutTabProps {
  tab: IAboutTab;
  activeTab: string;
}

export const AboutTab: FC<IAboutTabProps> = ({ tab, activeTab }) => {
  const isMoscowOrMO = useSelector(selectIsMoscowOrMO);

  const componentMapper: Record<string, ReactElement> = useMemo(
    () => ({
      main: (
        <AboutTabComponent
          firstColumnParagraphs={
            tab.firstColumnParagraphs &&
            (isMoscowOrMO && tab.firstColumnParagraphs.mimo
              ? tab.firstColumnParagraphs.mimo
              : tab.firstColumnParagraphs.default)
          }
          secondColumnParagraphs={tab.secondColumnParagraphs}
        />
      ),
      facts: <AboutTabWithIcons icons={tab.icons || []} />,
      history: <AboutTabWithIcons icons={tab.icons || []} />,
    }),
    [tab.firstColumnParagraphs, tab.secondColumnParagraphs, tab.icons, isMoscowOrMO],
  );

  return componentMapper[activeTab] || null;
};
